<template>
  <v-container grid-list-lg>
    <v-row no-gutters>
      <v-col>
        <Header
          :title="'Objednávky'"
          :subtitle="'V marketingu platí zásada, že treba prezentovať výhody a nie vlastnosti produktov. Pomôžte zákazníkovi vyriešiť jeho problém, splniť jeho túžbu.'"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <OrderInfoBar />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="orders"
          :search="search"
          :items-per-page="20"
          class="elevation-0 transparent"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent">
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:item.orderStatus="{ item }">
            <Tooltip :data="getOrderStatus(item.orderStatus)" />
          </template>
          <template v-slot:item.isConfirmed="{ item }">
            <v-btn
              v-if="!item.isConfirmed && item.orderStatus != 'Canceled'"
              color="success"
              small
              @click="confirmOrder(item)"
              text
            >potvrdiť objednávku</v-btn>
            <span v-if="item.orderStatus == 'Canceled'">--</span>
            <span v-if="item.isConfirmed && item.orderStatus != 'Canceled'">potvrdená / zaplatená</span>
          </template>
          <template v-slot:item.created="{ item }">
            <span>{{ item.created | moment("dddd, Do MMMM YYYY o HH:mm") }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  color="info"
                  class="mr-2"
                  v-on="on"
                  @click="goToOrder(item)"
                >mdi-information-variant</v-icon>
              </template>
              <span>Detail objednávky</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-on="on"
                  @click="downloadOrderInCsv(item)"
                >mdi-cloud-download-outline</v-icon>
              </template>
              <span>Export do MRP</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  color="accent"
                  class="mr-2"
                  v-on="on"
                  @click="getOrderDetail(item.orderId)"
                >mdi-clipboard-text</v-icon>
              </template>
              <span>Detail skladových kariet</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.orderStatus == 'Done'">
              <template v-slot:activator="{ on }">
                <v-icon
                  :color="item.finishEmail ? 'secondary' : 'primary'"
                  class="mr-2"
                  v-on="on"
                  @click="sendEmail(item)"
                >mdi-email-send</v-icon>
              </template>
              <span v-if="item.finishEmail == false">Odoslať email o dokončení objednávky</span>
              <span v-else>Email bol už odoslaný.</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.orderStatus == 'Done'">
              <template v-slot:activator="{ on }">
                <v-icon
                  color="success"
                  class="mr-2"
                  v-on="on"
                  @click="finishOrder(item)"
                >mdi-arrow-right-bold-box</v-icon>
              </template>
              <span>Ukončiť objednávku</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.orderStatus == 'New'">
              <template v-slot:activator="{ on }">
                <v-icon color="error" class="mr-2" v-on="on" @click="cancelOrder(item)">mdi-cancel</v-icon>
              </template>
              <span>Zrušiť objednávku</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="unset">
      <v-card>
        <StorageCardList :storageCards="orderDetail" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" color="primary">zatvor</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import StorageCardList from "@/views/storage_card/components/StorageCardList";
import OrderInfoBar from "./components/OrderInfoBar";
import Tooltip from "@/components/Tooltip";
import Header from "@/components/Header";
import { tableHeaderOrders, orderStatusTypes } from "./js/order";
import {
  tableHeader
  // storageCardTypes
} from "@/views/storage_card/js/storageCard";

export default {
  name: "Order",
  components: {
    OrderInfoBar,
    StorageCardList,
    Tooltip,
    Header
  },
  data: () => ({
    dialog: false,
    headers: tableHeaderOrders,
    headers2: tableHeader,
    search: "",
    orders: [],
    orderDetail: [],
    orderStatusTypes: orderStatusTypes
  }),

  computed: {},

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.services
        .orderService()
        .getOrders()
        .then(response => {
          this.orders = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    downloadOrderInCsv(order) {
      if (!confirm("Chcete spraviť export do MRP?")) {
        return;
      }

      this.openGlobalLoader("Generuje sa výstup ...");
      this.services
        .orderService()
        .getOrderCsv(order.orderId)
        .then(response => {
          if (this.checkResponse(response)) {
            console.log("response is ok");
          } else {
            this.openGlobalAlert(
              this.getTranslate("errors." + response.data.code),
              "error"
            );
            return;
          }

          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "data:text/csv; charset=utf-8"
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${order.customerName}_${order.orderId}.txt`
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    confirmOrder(item) {
      if (!confirm("Naozaj chcete potvrdiť objednávku? Je zaplatená?")) {
        return;
      }

      item.isConfirmed = true;
      this.save(item);
    },

    save(item) {
      this.openGlobalLoader("Ukladá sa ...");
      this.services
        .orderService()
        .putOrder(item.orderId, item)
        .then(() => {
          this.openGlobalAlert("Data boli uložené.", "success");
          this.initialize();
        })
        .catch(error => {
          console.error(error);
          this.openGlobalAlert("Chyba pri ukladaní!", "error");
          this.closeGlobalLoader();
        });
    },
    cancel() {
      this.openGlobalAlert("Canceled", "warning");
    },
    open() {
      // this.openGlobalAlert("Dialog opened", "info");
    },
    close() {
      console.log("Dialog closed");
    },

    getOrderStatus(status) {
      return orderStatusTypes.filter(item => item.id == status)[0];
    },

    getOrderDetail(orderId) {
      this.openGlobalLoader("Načitáva sa ...");
      this.services
        .orderService()
        .getOrderStorageCards(orderId)
        .then(response => {
          this.orderDetail = response.data;
          this.dialog = true;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    sendEmail(item) {
      if (!confirm("Chcete odoslať ukončovací email?")) {
        return;
      }

      this.openGlobalLoader("Odosiela sa ...");
      this.services
        .orderService()
        .sendFinishingEmail(item.orderId)
        .then(response => {
          console.log(response);
          this.openGlobalAlert("Email bol úspešne odoslaný.", "success");
        })
        .catch(error => {
          console.error(error);
          this.openGlobalAlert("Chyba pri odosielaní emailu!", "error");
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    finishOrder(item) {
      if (!confirm("Chcete ukončiť objednávku?")) {
        return;
      }

      this.openGlobalLoader("Odosiela sa ...");
      this.services
        .orderService()
        .finishOrder(item.orderId)
        .then(response => {
          console.log(response);
          this.openGlobalAlert("Objednávka ukončená.", "success");
          this.initialize();
        })
        .catch(error => {
          console.error(error);
          this.openGlobalAlert("Chyba pri ukončovaní objednávky!", "error");
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    cancelOrder(item) {
      if (!confirm("Chcete zrušiť objednávku?")) {
        return;
      }

      this.openGlobalLoader("Odosiela sa ...");
      this.services
        .orderService()
        .cancelOrder(item.orderId)
        .then(response => {
          if (this.checkResponse(response)) {
            console.log("response is ok");
          } else {
            this.openGlobalAlert(
              this.getTranslate("errors." + response.data.code),
              "error"
            );
            return;
          }
          this.openGlobalAlert("Objednávka zrušená.", "success");
          this.initialize();
        })
        .catch(error => {
          console.error(error);
          this.openGlobalAlert("Chyba pri rušení objednávky!", "error");
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    goToOrder(order) {
      this.$router.push(`/orders/${order.orderId}`);
    }
  }
};
</script>
